import React, { useState } from "react";
const baseURL =
  process.env.REACT_APP_BASE_URL ?? "https://ipublisher-microservices.6lgx.com";
const ReactImage = ({
  src = `${baseURL}/public/assets/images/svg/team-logo-22x22.svg`,
  width = 22,
  height = 22,
  clz = "",
  alt = "Image Description",
  priority = false,
  testid = "",
  fallbackSrc = `${baseURL}/public/assets/images/svg/team-logo-22x22.svg`,
  fill = false,
  sizes,
  objectFit = "cover",
  style = {},
  decoding = "async",
}) => {
  const [errored, setErrored] = useState(false);

  return (
    <img
      key={src}
      src={errored ? fallbackSrc : src}
      alt={alt}
      width={fill ? "100%" : width}
      height={fill ? "100%" : height}
      className={clz}
      style={{ objectFit, ...style }}
      data-testid={testid}
      decoding={decoding}
      loading={priority ? "eager" : "lazy"}
      onError={() => setErrored(true)}
    />
  );
};

export default ReactImage;
